import React from 'react';
import Chip from '@mui/material/Chip';
import { alpha } from '@mui/material/styles';
import { taskTypeColor, taskTypeLabel } from './taskOptions';

interface Props {
	type: string;
}

/** Soft tinted chip: the type's colour as text on a light wash of it, so the column reads at a glance without shouting. */
export default function TaskTypeChip({ type }: Props) {
	const color = taskTypeColor(type);
	return (
		<Chip
			size="small"
			label={taskTypeLabel(type)}
			sx={{ bgcolor: alpha(color, 0.18), color, fontWeight: 500, border: 0 }}
		/>
	);
}
